import { useTranslation } from 'react-i18next'
import { LayoutGrid, Search, Package, Pencil } from 'lucide-react'
import type { InputTab } from './useCampaignCreator'

const TABS: Array<{ id: InputTab; Icon: React.ComponentType<{ className?: string }> }> = [
  { id: 'asin',    Icon: LayoutGrid },
  { id: 'keyword', Icon: Search },
  { id: 'produkt', Icon: Package },
  { id: 'manuell', Icon: Pencil },
]

interface CampaignCreatorTabsProps {
  value: InputTab
  onChange: (tab: InputTab) => void
}

export function CampaignCreatorTabs({ value, onChange }: CampaignCreatorTabsProps) {
  const { t } = useTranslation()
  return (
    <div className="campaign-creator-tabs inline-flex gap-0.5 rounded-[11px] border border-neutral-200 dark:border-neutral-700 bg-neutral-100 dark:bg-neutral-800 p-1"
         role="tablist">
      {TABS.map(({ id, Icon }) => (
        <button key={id} role="tab" aria-selected={value === id}
                onClick={() => onChange(id)}
                className={[
                  'flex items-center gap-1.5 rounded-[8px] px-3.5 py-1.5 text-sm font-medium transition-all',
                  value === id
                    ? 'bg-primary-500 text-white font-semibold shadow-sm'
                    : 'text-neutral-500 dark:text-neutral-400 hover:text-neutral-800 dark:hover:text-white',
                ].join(' ')}>
          <Icon className="h-3.5 w-3.5" aria-hidden="true" />
          {t(`campaignCreator.tabs.${id}`)}
        </button>
      ))}
    </div>
  )
}
